import { AiButton } from '@ardoq/button';
import { colors } from '@ardoq/design-tokens';
import { BadgeDot, BadgeDotSize, StatusType } from '@ardoq/status-ui';
import styled from 'styled-components';
import type { ActionMenuAiButton } from './types';

const Container = styled.div`
  position: relative;
  display: inline-flex;
`;

const PositionedNotificationDot = styled(BadgeDot)`
  position: absolute;
  top: -2px;
  right: -2px;
  z-index: 3;
  pointer-events: none;
  outline: 2px solid ${colors.orange200};
  border-radius: 50%;
`;

export const AiActionButton = ({ action }: { action: ActionMenuAiButton }) => (
  <Container>
    <AiButton
      onClick={action.onClick}
      aria-label={action.label}
      data-tooltip-text={action.label}
      isDisabled={action.state === 'disabled'}
      isLoading={action.state === 'loading'}
      isActive={action.state === 'active'}
    />
    {action.hasNotification && (
      <PositionedNotificationDot
        aria-hidden
        color={StatusType.ERROR}
        size={BadgeDotSize.SMALL}
      />
    )}
  </Container>
);
